<template>
  <div class="employee">
    <h2 class="employee__title">{{ $t(`${namespace}.title`) }}</h2>
    <div class="employee__line">
      <div v-if="data && data.employeeName" class="employee__item">
        <div class="employee__item__label">{{ $t(`${namespace}.employeeName`) }}</div>
        <div class="employee__item__value text--ellipsis">{{ data.employeeName }}</div>
      </div>

      <div v-if="data && data.costCenterName" class="employee__item">
        <div class="employee__item__label">{{ $t(`${namespace}.costCenterName`) }}</div>
        <div class="employee__item__value text--ellipsis">{{ data.costCenterName }}</div>
      </div>

      <div v-if="data && data.projectName">
        <div class="employee__item__label">{{ $t(`${namespace}.projectName`) }}</div>
        <div class="employee__item__value text--ellipsis">{{ data.projectName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmployeeInfo',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.rideList.details.employee'
    }
  }
}
</script>

<style lang="scss" scoped>
.employee {
  padding: 0 0 24px;
}

.employee__title {
  color: $gray-7;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  line-height: normal;
  margin-bottom: 16px;
}

.employee__item__label {
  color: $gray-6;
  font-size: 12px;
}

.employee__item__value {
  margin-bottom: 8px;
}
</style>
